import axios from 'axios';

const apiEndpoint = process.env.REACT_APP_SERVER_API;

const api = axios.create({
  baseURL: apiEndpoint,
});

export default api;
